import request from './request'

export default {
  list(data) {
    return request.post('/videoFragment/list', data)
  },
  info(data) {
    return request.post('/videoFragment/info', data)
  },
  save(data) {
    return request.post('/videoFragment/save', data)
  },
  enable(data) {
    return request.post('/videoFragment/enable', data)
  },
  disable(data) {
    return request.post('/videoFragment/disable', data)
  },
  delete(data) {
    return request.post('/videoFragment/delete', data)
  },

  source(data) {
    return request.post('/videoFragment/source', data)
  },

  saveMultiple(data) {
    return request.post('/videoFragment/saveMultiple', data)
  },
}
